'use client'

import Image from 'next/image'
import React, { ComponentProps } from 'react'

export const DefaultBanner = (props: Partial<ComponentProps<typeof Image>>) => {
  return (
    <div role="banner" aria-label="default-banner">
      <Image {...props} src="/images/banners/unlimited-1on1-lesson.png" alt="default banner" />
    </div>
  )
}
